module.exports = __webpack_public_path__ + "static/img/2.803e780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/6/2.png
// module id = ceEw
// module chunks = 1